// extracted by mini-css-extract-plugin
module.exports = {"comp":"JJ_comp__Iwt9e"};